import { cn } from 'lib/helpers/utility';

const OptionCard = ({ isSelected, onSelect, className, children, ...rest }) => {
  const isInteractive = !!onSelect;

  const handleKeyDown = (event) => {
    // Keys pressed on controls nested inside the card belong to them, not the card.
    if (event.target !== event.currentTarget) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onSelect();
  };

  return (
    <div
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-pressed={isInteractive ? isSelected : undefined}
      onClick={onSelect}
      onKeyDown={isInteractive ? handleKeyDown : undefined}
      className={cn(
        'flex cursor-pointer items-center rounded-xl border border-solid bg-white outline-none transition-[box-shadow,border-color] duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
        isSelected
          ? 'border-primary-300 shadow-[4px_4px_12px_0px_rgba(0,0,0,0.08),0px_0px_0px_2.5px_#CBF0FD]'
          : 'border-neutral-300 shadow-[0px_4px_12px_0px_rgba(65,70,81,0.08)] hover:border-neutral-400',
        className
      )}
      {...rest}>
      {children}
    </div>
  );
};

export default OptionCard;
